<template lang="pug">
#modal-editar-cadastrar-representante
    el-dialog(
        width='600px',
        :title="`${editar ? $t('mensagens.comuns.editar') : $t('mensagens.comuns.cadastrar')} ${$t('mensagens.pessoas.pessoa')}`"
        :visible.sync='mostrar',
        :close-on-click-modal='false',
        :before-close='fechar'
    )
        el-form(label-position='top')
            el-form-item
                template(slot='label')
                    span {{ $t('mensagens.comuns.pais') }}
                    span.invalido(v-if='$v.pais.$invalid') *

                el-select.w-100(
                    v-model='tipoDocumento.id',
                    :disabled='editar',
                    @change='atualizarDocumento'
                )
                    el-option(
                        v-for='tipo in tiposDocumento',
                        :key='tipo.id',
                        :label='tipo.pais',
                        :value='tipo.id'
                    )
            el-form-item
                template(slot='label')
                    span {{ $t('mensagens.pessoas.nomeRazaoSocial') }}
                    span.invalido(v-if='$v.nomeRazaoSocial.$invalid') *

                el-input.w-100(
                    v-model='nomeRazaoSocial',
                    maxlength='50',
                    :placeholder="$t('mensagens.pessoas.nomeRazaoSocial')"
                )

            el-form-item
                template(slot='label')
                    span {{ $t('mensagens.pessoas.documento') }} ({{ tipoDocumento.nome }})
                    span.invalido(v-if='$v.documento.$invalid') *
                    span.invalido(v-else-if='!documentoValido') &nbsp;{{ $t('mensagens.pessoas.documentoInvalido') }}

                .brasil(v-if='tipoDocumento.nome === "CPF/CNPJ"')
                    el-input.w-100(
                        v-model='documento',
                        :placeholder="$t('mensagens.pessoas.numeroCpfCnpj')",
                        :disabled='editar',
                        v-mask='["###.###.###-##", "##.###.###/####-##"]'
                    )

                .paraguai(v-if='tipoDocumento.nome === "RUC"')
                    el-input.w-100(
                        v-model='documento',
                        :placeholder="$t('mensagens.pessoas.numeroRuc')",
                        :disabled='editar',
                        v-mask='["#######-#", "########-#"]'
                    )

                .argentina(v-if='tipoDocumento.nome === "CUIT/DNI"')
                    el-input.w-100(
                        v-model='documento',
                        :placeholder="$t('mensagens.pessoas.numeroCuitDni')",
                        :disabled='editar',
                        v-mask='["##-########-#", "#########"]'
                    )

            el-form-item
                template(slot='label')
                    span {{ $t('mensagens.pessoas.idCliente') }}

                el-input.w-100(
                    v-model='idCliente',
                    maxlength='200',
                    :placeholder="$t('mensagens.pessoas.idCliente')"
                )

            el-form-item(v-if='editar && fPL1182CodigoLyraPessoa')
                template(slot='label')
                    span {{ $t('mensagens.pessoas.codigoLyra') }}

                el-input.w-100(
                    v-model='dadosRepresentante.codigoLyra',
                    :disabled='true'
                )

            el-form-item
                template(slot='label')
                    span Email
                    span.invalido(v-if='$v.email.$invalid') &nbsp;{{ $t('mensagens.pessoas.emailInvalido') }}

                el-input.w-100(v-model='email', placeholder='Email', maxlength='250')

            el-form-item
                template(slot='label')
                    span {{ $t('mensagens.pessoas.numeroCelular') }}
                input.w-100.el-input__inner.phone-input(v-model='telefone', type='text', id='telefone', ref='telefone',
                    @input="maskPhoneNumber('telefone', 'itiTelefone')", placeholder="Ex: 11912345678",
                    maxlength='40',
                    :class="{'phone-error-border': telefoneError }")
                span.phone-message(v-if='!telefoneError') {{ $t('mensagens.pessoas.insiraApenasNumeros') }}
                span.phone-message.text-danger(v-else) {{ $t('mensagens.pessoas.numeroTelefoneInvalido') }}

                p.extra-phone(v-if='!mostrarTelefoneAdicional' @click="mostrarTelefoneAdicional = true") {{ $t('mensagens.pessoas.adicionarTelefoneExtra') }}

                div(v-show='mostrarTelefoneAdicional')
                    span.label-green {{ $t('mensagens.pessoas.numeroCelularAdicional') }}
                    input.w-100.el-input__inner.phone-input(v-model='telefoneAdicional', type='text', id='telefoneAdicional', ref='telefoneAdicional',
                        @input="maskPhoneNumber('telefoneAdicional', 'itiTelefoneAdicional')",placeholder="Ex: 11912345678",
                        maxlength='40',
                        :class="{'phone-error-border': telefoneAdicionalError }")
                    span.phone-message(v-if='!telefoneAdicionalError')  {{ $t('mensagens.pessoas.insiraApenasNumeros') }}
                    span.phone-message.text-danger(v-else) {{ $t('mensagens.pessoas.numeroTelefoneInvalido') }}

            el-form-item
                template(slot='label')
                    span {{ $t('mensagens.pessoas.grupoEmpresa') }}

                el-input.w-100(
                    v-model='grupoEmpresas',
                    :placeholder="$t('mensagens.pessoas.nomeRazaoSocial')",
                    maxlength='50',
                    show-word-limit
                )

            el-form-item
                template(slot='label')
                    span {{ $t('mensagens.pessoas.tipoProduto') }}

                el-select.w-100(
                        v-model='tipoProduto'
                    )
                        el-option(
                            v-for='tipo in tiposProduto',
                            :key='tipo.chave',
                            :label='tipo.descricao',
                            :value='tipo.chave'
                        )

            el-form-item(v-if="tipoDocumento.id === 1")
                template(slot='label')
                    span {{ $t('mensagens.pessoas.carProprio') }}

                el-select.w-100(
                        v-model='carProprio'
                    )
                        el-option(
                            v-for='resp in simNao',
                            :key='resp.chave',
                            :label='resp.descricao',
                            :value='resp.value'
                        )

        footer.espaco(slot='footer')
            BaseButton(type='default', @click='fechar') {{ $t('mensagens.comuns.cancelar') }}

            BaseButton(
                type='primary',
                :disabled='$v.email.$invalid || $v.nomeRazaoSocial.$invalid || !documentoValido || telefoneError || telefoneAdicionalError',
                @click='salvar'
            ) {{ $t('mensagens.comuns.salvar') }}

    ModalAtalhoTerritorio(
        :mostrar='mostrarModalRedirecionamentoTerritorio',
        @fechar='fecharModalAtalhoTerritorio'
    )
</template>

<script>
import RepresentanteService from '@/services/RepresentanteService';

import formatters from '@/utils/formatters';
import validators from '@/utils/validators';

import { required, email } from 'vuelidate/lib/validators';

import ModalAtalhoTerritorio from '@/components/ModalAtalhoTerritorio';
import BaseButton from '@/components/vegaComponents/BaseButton';
import { mapActions, mapGetters } from 'vuex';
import intlTelInput from 'intl-tel-input';
import 'intl-tel-input/build/css/intlTelInput.css';
import pt from 'intl-tel-input/build/js/i18n/pt';
import en from 'intl-tel-input/build/js/i18n/en';
import es from 'intl-tel-input/build/js/i18n/es';
import { formatFlag } from '@/utils/featureFlags/featureFlag';
import { FeatureFlagConst } from '@/constants/FeatureFlag';

export default {
    name: 'ModalEditarCadastrarRepresentante',
    components: {
        ModalAtalhoTerritorio,
        BaseButton
    },
    props: {
        mostrar: {
            type: Boolean,
            required: true
        },

        editar: {
            type: Boolean,
            required: false,
            default: false
        },

        dadosRepresentante: {
            type: Object,
            required: false,
            default: null
        },

        isVincularPessoaParaguai: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            pais: '',
            nomeRazaoSocial: '',
            documento: '',
            email: '',
            telefone: '',
            telefoneAdicional: '',
            idCliente: '',
            mostrarModalRedirecionamentoTerritorio: false,
            tiposDocumento: [],
            tiposProduto: [ { chave: 'DIRETO', descricao: this.$t('mensagens.pessoas.direto') }, { chave: 'INDIRETO', descricao: this.$t('mensagens.pessoas.indireto') } ],
            simNao: [ { chave: 'sim', descricao: this.$t('mensagens.comuns.sim'), value: true }, { chave: 'nao', descricao: this.$t('mensagens.comuns.nao'), value: false } ],
            tipoDocumento: null,
            ruc: '',
            rucDv: '',
            grupoEmpresas: '',
            tipoProduto: '',
            carProprio: '',
            itiTelefone: {},
            itiTelefoneAdicional: {},
            mostrarTelefoneAdicional: false,
            telefoneError: false,
            telefoneAdicionalError: false,
            i18nMap: {
                'pt-BR': pt,
                'en': en,
                'es': es
            },
            fPL1182CodigoLyraPessoa: this.$unleash.isEnabled(formatFlag(FeatureFlagConst.FF1182_CODIGO_LYRA_PESSOAS))
        };
    },

    mounted() {
        this.tipoDocumento = this.getDefaultTipoDocumento();
        this.buscarTiposDocumento();
    },

    computed: {
        ...mapGetters(['ambienteAr']),
        documentoValido() {
            if (!this.documento) return false;

            switch (this.tipoDocumento.nome) {
                case 'RUC':
                    return validators.validarDocumento(this.documento, 'RUC');
                case 'CUIT/DNI':
                    return validators.validarCUIT(this.documento);
                default:
                    return validators.validarDocumento(this.documento);
            }
        }
    },

    validations: {
        pais: {
            required
        },
        nomeRazaoSocial: {
            required
        },
        documento: {
            required
        },
        email: {
            email
        },

        representante: ['pais', 'nomeRazaoSocial', 'documento', 'email']
    },

    watch: {
        mostrar(newValue) {
            if (Object.keys(this.dadosRepresentante).length > 0) {
                this.nomeRazaoSocial = this.dadosRepresentante.nomeRazaoSocial;
                const numero = formatters.documentoFormatToNumeral(this.dadosRepresentante.cpfCnpj || '');
                this.documento = formatters.numeralStringFormatToDocumento(numero,
                    this.dadosRepresentante.tipoDocumento.nome
                );
                this.email = this.dadosRepresentante.email;
                this.idCliente = this.dadosRepresentante.idCliente;
                this.tipoDocumento = {
                    id: this.dadosRepresentante.tipoDocumento.id,
                    nome: this.dadosRepresentante.tipoDocumento.nome,
                    siglaPais: this.dadosRepresentante.tipoDocumento.siglaPais
                };
                this.grupoEmpresas = this.dadosRepresentante.grupoEmpresas;
                this.tipoProduto = this.dadosRepresentante.tipoProduto;
                this.carProprio = this.dadosRepresentante.carProprio;
                this.telefone = this.getPhoneNumber(this.dadosRepresentante.telefone);
                this.telefoneAdicional = this.getPhoneNumber(this.dadosRepresentante.telefoneAdicional);
            }
            if (newValue) {
                this.initializeIntTel('telefone', 'itiTelefone');
                this.initializeIntTel('telefoneAdicional', 'itiTelefoneAdicional');
            }
            if (this.telefoneAdicional) {
                this.mostrarTelefoneAdicional = true;
            }
        }
    },

    methods: {
        ...mapActions(['setRepresentante']),

        fechar() {
            this.nomeRazaoSocial = '';
            this.documento = '';
            this.email = '';
            this.idCliente = '';
            this.tipoDocumento = this.getDefaultTipoDocumento();
            this.grupoEmpresas = '';
            this.tipoProduto = '';
            this.carProprio = '';
            this.telefone = '';
            this.telefoneAdicional = '';
            this.mostrarTelefoneAdicional = false;
            this.telefoneError = false;
            this.telefoneAdicionalError = false;

            this.$emit('fechar');
        },

        fecharModalAtalhoTerritorio() {
            this.nomeRazaoSocial = '';
            this.documento = '';
            this.email = '';
            this.idCliente = '';
            this.tipoDocumento = this.getDefaultTipoDocumento();
            this.grupoEmpresas = '';
            this.tipoProduto = '';
            this.carProprio = '';
            this.telefone = '';
            this.telefoneAdicional = '';
            this.mostrarTelefoneAdicional = false;
            this.telefoneError = false;
            this.telefoneAdicionalError = false;
            this.mostrarModalRedirecionamentoTerritorio = false;
        },

        atualizarListaRepresentantes() {
            this.$emit('atualizarListaRepresentantes');
        },

        salvar() {
            this.editar
                ? this.editarRepresentante()
                : this.cadastrarRepresentante();
        },

        async editarRepresentante() {
            try {
                if (this.telefoneAdicional && !this.telefone) {
                    this.$notify.warning({
                        message: this.$t('mensagens.pessoas.necessarioTelefonePrincipal')
                    });
                    return;
                }
                await RepresentanteService.editarRepresentante({
                    id: this.dadosRepresentante.id,
                    nomeRazaoSocial: this.nomeRazaoSocial,
                    cpfCnpj: formatters.documentoFormatToNumeral(this.documento),
                    email: this.email,
                    idCliente: this.idCliente,
                    tipoDocumento: {
                        id: this.tipoDocumento.id
                    },
                    grupoEmpresas: this.grupoEmpresas,
                    tipoProduto: this.tipoProduto,
                    carProprio: this.carProprio,
                    telefone: this.getPhoneWithDDIAndIso2(this.telefone, this.itiTelefone),
                    telefoneAdicional: this.getPhoneWithDDIAndIso2(this.telefoneAdicional, this.itiTelefoneAdicional)
                });

                this.fechar();
                this.atualizarListaRepresentantes();

                this.$notify.success({
                    message: this.$t('mensagens.pessoas.pessoaEditadaComSucesso')
                });
            } catch (e) {
                if (e.response.status === 400) {
                    this.$notify.warning({
                        message: this.$t(e.response.data.message)
                    });
                } else {
                    this.$notify.error({
                        message: this.$t('mensagens.comuns.erros.inesperadoServidor')
                    });
                }
            }
        },

        redirecionarTerritorio() {
            this.mostrarModalRedirecionamentoTerritorio = true;
        },

        async cadastrarRepresentante() {
            try {
                if (this.telefoneAdicional && !this.telefone) {
                    this.$notify.warning({
                        message: this.$t('mensagens.pessoas.necessarioTelefonePrincipal')
                    });
                    return;
                }
                const { data } =
                    await RepresentanteService.cadastrarRepresentante({
                        nomeRazaoSocial: this.nomeRazaoSocial,
                        cpfCnpj: formatters.documentoFormatToNumeral(
                            this.documento
                        ),
                        email: this.email,
                        idCliente: this.idCliente,
                        tipoDocumento: {
                            id: this.tipoDocumento.id,
                            siglaPais: this.tipoDocumento.siglaPais
                        },
                        grupoEmpresas: this.grupoEmpresas,
                        tipoProduto: this.tipoProduto,
                        carProprio: this.carProprio,
                        telefone: this.getPhoneWithDDIAndIso2(this.telefone, this.itiTelefone),
                        telefoneAdicional: this.getPhoneWithDDIAndIso2(this.telefoneAdicional, this.itiTelefoneAdicional)
                    });

                this.setRepresentante(data);

                this.fechar();
                this.atualizarListaRepresentantes();

                this.$notify.success({
                    message: this.$t('mensagens.pessoas.pessoaAdicionadaComSucesso')
                });

                if (!this.isVincularPessoaParaguai) {
                    this.redirecionarTerritorio();
                }
            } catch (e) {
                if (e.response.status === 400) {
                    this.$notify.warning({
                        message: this.$t(e.response.data.message)
                    });
                } else {
                    this.$notify.error({
                        message: this.$t('mensagens.comuns.erros.inesperadoServidor')
                    });
                }
            }
        },

        async buscarTiposDocumento() {
            try {
                const { data } =
                    await RepresentanteService.buscarTipoDocumento();

                let documentos = data;

                if (this.ambienteAr) {
                    documentos = data.filter(doc => doc.nome !== 'RUC');
                }

                this.tiposDocumento = documentos;

                setTimeout(() => {
                    if (this.isVincularPessoaParaguai) {
                        this.tipoDocumento.id = 2;
                        this.atualizarDocumento();
                    } else if (this.ambienteAr) {
                        this.tipoDocumento.id = 3;
                        this.atualizarDocumento();
                    }
                }, 500);
            } catch (error) {
                this.$notify.error({
                    message: this.$t('mensagens.pessoas.erroAoBuscarTipoDocumento')
                });
            }
        },

        atualizarDocumento() {
            const selectedTipoDocumento = this.tiposDocumento.find(
                t => t.id === this.tipoDocumento.id
            );
            this.tipoDocumento.nome = selectedTipoDocumento.nome;
            this.tipoDocumento.siglaPais = selectedTipoDocumento.siglaPais;

            if (!this.editar) {
                this.itiTelefone.setCountry(this.tipoDocumento.siglaPais);
                this.itiTelefoneAdicional.setCountry(this.tipoDocumento.siglaPais);
            }
        },

        initializeIntTel(component, itiVariable) {
            this.$nextTick(() => {
                const input = this.$refs[component];
                if (input) {
                this[itiVariable] = intlTelInput(input, {
                    containerClass: 'w-100',
                    initialCountry: this.tipoDocumento.siglaPais,
                    i18n: this.i18nMap[this.$i18n.locale]
                });

                if (this.editar && this.dadosRepresentante && this.dadosRepresentante[component]) {
                    const country = this.getCountry(this[itiVariable], this.dadosRepresentante[component]);
                    if (country) this[itiVariable].setCountry(country.iso2);
                }

                input.addEventListener('countrychange', () => {
                    this.maskPhoneNumber(component, itiVariable);
                });
                }
            });
        },

        maskPhoneNumber(key, iti) {
            let input = this[key].replace(/\D/g, '');
            let errorKey = key + 'Error';

            if (iti && this[iti].getSelectedCountryData().iso2 === 'br') {
                if (input.length > 11) {
                    input = input.substring(0, 11);
                }
                if (input.length > 0) {
                    input = input.replace(/^(\d{0,2})/, '($1');
                }
                if (input.length > 3) {
                    input = input.replace(/^(\(\d{2})(\d{0,5})/, '$1) $2');
                }
                if (input.length > 9) {
                    input = input.replace(/(\d{5})(\d{0,4})$/, '$1-$2');
                }
                if (input.length !== 15 && input.length !== 0) {
                    this[errorKey] = true;
                } else {
                    this[errorKey] = false;
                }
            } else {
                this[errorKey] = false;
            }
            this[key] = input;
        },

        getPhoneWithDDIAndIso2(phoneNumber, iti) {
            if (phoneNumber && iti.getSelectedCountryData().dialCode && iti.getSelectedCountryData().iso2 && iti) {
                return `${iti.getSelectedCountryData().iso2} +${iti.getSelectedCountryData().dialCode} ${phoneNumber}`;
            } else {
                return '';
            }
        },

        getPhoneNumber(intPhone) {
            if (!intPhone) return '';
            // Remove the first two characters which represent the country iso2 code
            const phoneWithoutCountryCode = intPhone.slice(2).trim();
            // Remove the international code and return the phone number
            return phoneWithoutCountryCode.replace(/^\+\d{1,3}\s?/, '');
        },

        getCountry(iti, phoneNumber) {
            const iso2 = phoneNumber.slice(0, 2).trim();
            return iti.countries.find(x => x.iso2 === iso2);
        },

        getDefaultTipoDocumento() {
            if (this.isVincularPessoaParaguai) {
            return { id: 2, nome: 'RUC', siglaPais: 'PY' };
            }
            if (this.ambienteAr) {
            return { id: 3, nome: 'CUIT/DNI', siglaPais: 'AR' };
            }
            return { id: 1, nome: 'CPF/CNPJ', siglaPais: 'BR' };
        }
    }
};
</script>

<style lang="scss">
#modal-editar-cadastrar-representante {
    footer {
        display: flex;
        justify-content: space-between;
    }

    .invalido {
        color: var(--danger);
    }

    .espaco {
        display: flex;
    }

    .el-form-item .el-form-item__label {
        font-weight: normal !important;
    }

    .iti {
        --iti-path-flags-1x: url('../../node_modules/intl-tel-input/build/img/flags.webp');
        --iti-path-flags-2x: url('../../node_modules/intl-tel-input/build/img/flags@2x.webp');
        --iti-path-globe-1x: url('../../node_modules/intl-tel-input/build/img/globe.webp');
        --iti-path-globe-2x: url('../../node_modules/intl-tel-input/build/img/globe@2x.webp');
    }

    .phone-input {
        padding-left: 50px;
    }

    .phone-error-border {
        border: 1px solid #F56C6C !important;
    }

    .phone-message {
        margin-left: 50px;
        font-size: 12px;
    }

    .extra-phone {
        color: var(--primary);
        font-weight: 500;
        cursor: pointer;
    }

    .label-green {
        color: var(--primary);
    }
}
</style>
